import Swiper, {
    Pagination
} from 'swiper';

$(document).on('ready', function () {

    const sectionCarouselBlog = $('.section-carousel-blog');

    if (!!$(sectionCarouselBlog) == true) {
        $(sectionCarouselBlog).each(function (index, slider) {
            const id = $(slider).attr('data-section-id');
            const carousel_selector = '.section-' + id + ' .swiper';
            const pagination_selector = '.section-' + id + ' .swiper-pagination';

            var swiper = new Swiper(carousel_selector, {
                slidesPerView: 1.3,
                slidesPerGroup: 1,
                centeredSlides: true,
                loop: false,
                modules: [Pagination],
                spaceBetween: 16,
                pagination: {
                    el: pagination_selector,
                    clickable: true
                },
                breakpoints: {
                    768: {
                        slidesPerView: 2.1,
                        loop: true,
                        spaceBetween: 50,
                        centeredSlides: true
                    },
                    1400: {
                        slidesPerView: 4,
                        loop: true,
                        spaceBetween: 50,
                        centeredSlides: true
                    }
                }
            });
        });
    }
});
